"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var message_exports = {};
__export(message_exports, {
  MessageEventType: () => MessageEventType
});
module.exports = __toCommonJS(message_exports);
var MessageEventType = /* @__PURE__ */ ((MessageEventType2) => {
  MessageEventType2["CreateMessage"] = "createMessage";
  MessageEventType2["UpdatePatch"] = "updatePatch";
  MessageEventType2["RemovePatch"] = "removePatch";
  MessageEventType2["ReactionPatch"] = "reactionPatch";
  MessageEventType2["BlobPatch"] = "blobPatch";
  MessageEventType2["AttachmentPatch"] = "attachmentPatch";
  MessageEventType2["ThreadPatch"] = "threadPatch";
  MessageEventType2["CreateMessagesGroup"] = "createMessagesGroup";
  MessageEventType2["RemoveMessagesGroup"] = "removeMessagesGroup";
  return MessageEventType2;
})(MessageEventType || {});
//# sourceMappingURL=message.js.map
